import './TipModal.scss';

import { useEffect, useState } from 'react';

import Button from 'atoms/button';

export default function CustomScreen({
  setScreen,
  onSetCustomTip,
  toggleModal,
}) {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const onConfirm = () => {
    onSetCustomTip(inputValue);
    toggleModal(false);
  };

  const handleNumberClick = (number) => () => {
    setInputValue((prevValue) => prevValue + number);
  };

  const handleKeyPress = (event) => {
    if ((event.key >= '0' && event.key <= '9') || event.key === '.') {
      setInputValue((prevValue) => prevValue + event.key);
    } else if (event.key === 'Backspace') {
      handleDelete();
    }
  };

  const handleDelete = () => {
    setInputValue((prevValue) => prevValue.slice(0, -1));
  };

  const formatCurrency = (value) => {
    const formatted = value.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    return `$${formatted || 0}`;
  };

  const onBack = () => {
    setScreen('selection');
  };
  return (
    <div className="pb-20">
      <div className="tip-modal-keypad">
        <div className="total-display mb-10 bold">
          {formatCurrency(inputValue)}
        </div>
        <div className="keypad">
          {[...Array(9)].map((el, index) => (
            <button
              key={el}
              className="b-white f24 c-black"
              onClick={handleNumberClick(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            className="b-white f24 c-black"
            onClick={handleNumberClick('.')}
          >
            .
          </button>
          <button
            className="b-white f24 c-black"
            onClick={handleNumberClick('0')}
          >
            0
          </button>
          <button className="b-white f24 c-black" onClick={handleDelete}>
            ←
          </button>
        </div>
      </div>
      <div className="flex-row justify-center ml-20 mr-20 mt-20">
        <Button
          className="w-100 mr-15"
          text="Confirm"
          size="medium"
          onClick={onConfirm}
        />
        <Button
          className="w-100"
          variant="reverse"
          text="Back"
          size="medium"
          onClick={onBack}
        />
      </div>
    </div>
  );
}
